import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useEffect, useState, useRef } from "react";
import useLogin from "../hooks/useLogin";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import config from "../config";
import zxcvbn from "zxcvbn";
function Login() {
  const navigate = useNavigate();
  useEffect(() => {
    localStorage.removeItem("token");
    localStorage.removeItem("CentCode");
    localStorage.removeItem("activeTab");
    localStorage.removeItem("schoolName");
    localStorage.removeItem("sessionId");
    localStorage.removeItem("token2");
    localStorage.removeItem("sessionId2");
  }, []);
  const [newPassword, setNewPassword] = useState("");
  const [isNewPasswordVisible, setIsNewPasswordVisible] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading2, setLoading] = useState(true);

  const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] =
    useState(false);
  const [notices, setNotices] = useState([]);

  const passwordStrength = zxcvbn(newPassword);
  const strengthLabels = [
    "Very Weak",
    "Weak",
    "Medium",
    "Strong",
    "Very Strong",
  ];
  const strengthColors = [
    "#e74c3c",
    "#e67e22",
    "#f1c40f",
    "#2ecc71",
    "#27ae60",
  ];

  const hasUpperCase = /[A-Z]/.test(newPassword);
  const hasLowerCase = /[a-z]/.test(newPassword);
  const hasNumber = /\d/.test(newPassword);
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(newPassword);
  const hasMinLength = newPassword.length >= 8;
  const {
    loading,
    showPassword,
    schoolCode,
    password,
    setShowPassword,
    setSchoolCode,
    setPassword,
    handleLogin,
    openModal,
    closeModal,
    modalRef,
  } = useLogin();

  const [captcha, setCaptcha] = useState("");
  const [userCaptcha, setUserCaptcha] = useState("");
  const [isCaptchaValid, setIsCaptchaValid] = useState(false);
  const canvasRef = useRef(null);
  const isVideo = (url) => {
    return (url || "").toLowerCase().endsWith(".mp4");
  };
  const generateCaptcha = () => {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let randomCaptcha = "";
    for (let i = 0; i < 6; i++) {
      randomCaptcha += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setCaptcha(randomCaptcha);
    setUserCaptcha(""); // Clear user input
    setIsCaptchaValid(false); // Reset validation state
    drawCaptcha(randomCaptcha);
  };
  const handleLoginWithCaptcha = async () => {
    if (!isCaptchaValid) {
      Swal.fire({
        icon: "error",
        title: "Invalid CAPTCHA",
        text: "Please enter the correct CAPTCHA.",
        confirmButtonColor: "#d33",
      });
      generateCaptcha();
      return;
    }

    await handleLogin();
    generateCaptcha();
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${config.API_BASE_URL}/auth/FetchAdminNoticeData`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          },
        );

        if (response.status !== 200) {
          Swal.fire({
            icon: "warning",
            title: "Data not found.",
          });
          setNotices([]);
        } else {
          const result = await response.json();
          const studentData = result?.data?.notice_details ?? [];

          if (studentData.length === 0) {
            Swal.fire({
              icon: "warning",
              title: "Data Not Found",
            });
          }
          setNotices(studentData);
          console.log(result);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        Swal.fire("Error", "Something went wrong!", "error");
        setNotices([]);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);
  const drawCaptcha = (captchaText) => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Set background color
    ctx.fillStyle = "#f0f0f0";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Set font style
    ctx.font = "italic bold 30px 'Courier New', monospace";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";

    // Add random noise for security
    for (let i = 0; i < 150; i++) {
      ctx.fillStyle = `rgba(0, 0, 0, ${Math.random() * 0.3})`;
      ctx.fillRect(
        Math.random() * canvas.width,
        Math.random() * canvas.height,
        1,
        1,
      );
    }

    // Draw distorted CAPTCHA text
    for (let i = 0; i < captchaText.length; i++) {
      const x = 20 + i * 20;
      const y = 20 + Math.random() * 5;
      const angle = (Math.random() - 0.5) * 0.5;

      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.fillStyle = `rgb(${Math.random() * 100}, ${Math.random() * 100}, ${Math.random() * 100})`;
      ctx.fillText(captchaText[i], 0, 0);
      ctx.restore();
    }
  };
  // Validate CAPTCHA input
  const validateCaptcha = (e) => {
    setUserCaptcha(e.target.value);
    setIsCaptchaValid(e.target.value === captcha);
  };

  useEffect(() => {
    generateCaptcha(); // Generate CAPTCHA on component mount
  }, []);
  const handleSubmit = async () => {
    // Regular expressions for validation
    const hasUpperCase = /[A-Z]/.test(newPassword);
    const hasLowerCase = /[a-z]/.test(newPassword);
    const hasNumber = /\d/.test(newPassword);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(newPassword);
    const hasMinLength = newPassword.length >= 8;

    // Check if both fields are filled
    if (!newPassword || !confirmPassword) {
      Swal.fire({
        icon: "warning",
        title: "Empty Fields",
        text: "Both password fields must be filled out.",
        confirmButtonColor: "#d33",
        customClass: { popup: "custom-swal" },
      });
      return;
    }

    // Check if passwords match
    if (newPassword !== confirmPassword) {
      Swal.fire({
        icon: "warning",
        title: "Passwords do not match",
        text: "Please enter the same password in both fields.",
        confirmButtonColor: "#d33",
        customClass: { popup: "custom-swal" },
      });
      return;
    }

    // Check password strength conditions
    if (
      !hasMinLength ||
      !hasUpperCase ||
      !hasLowerCase ||
      !hasNumber ||
      !hasSpecialChar
    ) {
      Swal.fire({
        icon: "warning",
        title: "Weak Password",
        text: "Password must be at least 8 characters long and include an uppercase letter, a lowercase letter, a number, and a special character.",
        confirmButtonColor: "#d33",
        customClass: { popup: "custom-swal" },
      });
      return;
    }

    try {
      Swal.fire({
        title: "Updating Password...",
        text: "Please wait while we update your password.",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      const token = localStorage.getItem("token");
      const centCode = localStorage.getItem("CentCode");

      const response = await fetch(
        `${config.API_BASE_URL}/Auth/UpdatePasswordAuthentication`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            CENTER_CODE: centCode,
            NEW_CENTER_PASSWORD: newPassword,
          }),
        },
      );

      const data = await response.json();
      // console.log(data);

      if (response.status === 200) {
        Swal.close();
        closeModal();
        navigate("/dashboard");
      } else if (response.status === 404) {
        throw new Error(
          "Center not found. Please check the details and try again.",
        );
      } else if (response.status === 401) {
        throw new Error("Unauthorized access. Please log in again.");
      } else if (response.status === 500) {
        throw new Error("Server error. Please try again later.");
      } else {
        throw new Error(data.message || "An unexpected error occurred.");
      }
    } catch (error) {
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "Something went wrong. Please try again.",
        confirmButtonColor: "#d33",
      });
    }
  };

  return (
    <div>
      {loading || loading2 && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}

      <div className="auth-main">
        <div className="auth-wrapper v3">
          <div className="auth-form">
            <div className="auth-header">
              <a href="#">
                <img src="../assets/images/MBOSE.png" height={110} alt="img" />
              </a>
            </div>
            <div>
              <h3 className="exam-name">Supplementary Examination Portal</h3>
            </div>
            <div
              style={{
                padding: "0px 20px",
                display: "flex",
                justifyContent: "space-between",
                width: "96%",
                gap: "20px",
              }}
            >
              {/* NOTICE CARD */}
              <div
                className="card"
                style={{
                  maxWidth: "66%",
                  borderRadius: 10,
                  overflow: "hidden",
                  boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 10px",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#188FFE",
                    padding: "10px 15px",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: 18,
                  }}
                >
                  NOTICE
                </div>

                <div style={{ padding: 5, maxHeight: 400, overflowY: "auto" }}>
                  <table
                    className="table table-bordered"
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      fontSize: 14,
                    }}
                  >
                    <thead>
                      <tr style={{ backgroundColor: "rgb(242, 242, 242)" }}>
                        <th style={{ width: "15%", padding: 5 }}>Date</th>
                        <th style={{ padding: 5 }}>Title</th>
                        <th style={{ width: "20%", padding: 5 }}></th>
                      </tr>
                    </thead>

                    <tbody>
                      {notices.length === 0 ? (
                        <tr>
                          <td
                            colSpan="3"
                            style={{ padding: 10, textAlign: "center" }}
                          >
                            No notices available.
                          </td>
                        </tr>
                      ) : (
                        notices.map((notice, index) => (
                          <tr
                            key={index}
                            style={{
                              backgroundColor:
                                index % 2 === 0
                                  ? "rgb(255, 255, 255)"
                                  : "rgb(249, 249, 249)",
                            }}
                          >
                            <td style={{ padding: 5 }}>{notice.SHOWING_DATE}</td>

                            <td style={{ padding: 5 }}>
                              <span
                                style={{
                                  color: "rgb(231, 76, 60)",
                                  fontWeight: "bold",
                                }}
                              >
                                 NOTICE {index+1} : 
                              </span>{" "}
                              {notice.NOTICE_DESCRIPTION}
                            </td>

                         <td style={{ padding: 5, textAlign: "center" }}>
                              {isVideo(notice.NOTICE_FILE_URL) ? (
                                <a
                                  className="btn btn-danger btn-sm"
                                  href={notice.NOTICE_FILE_URL}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  title="Play Video"
                                >
                                  <i className="fas fa-play me-1"></i> Play Video
                                </a>
                              ) : (
                                <a
                                  className="btn btn-danger btn-sm"
                                  href={notice.NOTICE_FILE_URL}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  title="Download PDF"
                                >
                                  <i className="fas fa-download me-1"></i> Download
                                </a>
                              )}
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* LOGIN CARD */}
              <div className="card" style={{ maxWidth: "33%", width: "100%" }}>
                <div className="card-body">
                  <div className="mb-4">
                    <h3 className="mb-0">
                      <b>Login</b>
                    </h3>
                  </div>

                  <div className="form-group mb-3">
                    <label className="form-label">Centre Code</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Centre Code"
                      value={schoolCode}
                      onChange={(e) => setSchoolCode(e.target.value)}
                      onKeyDown={(e) => {
                        const keyCode = e.which || e.keyCode;
                        if (
                          e.key !== "Backspace" &&
                          e.key !== "Delete" &&
                          e.key !== "Tab" &&
                          !(keyCode >= 48 && keyCode <= 57) &&
                          !(keyCode >= 96 && keyCode <= 105)
                        ) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>

                  <div className="form-group mb-3">
                    <label className="form-label">Password</label>
                    <div className="input-group mb-3">
                      <input
                        type={showPassword ? "text" : "password"}
                        className="form-control"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />

                      <span
                        className="input-group-text cursor-pointer"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? (
                          <FaEyeSlash size={20} />
                        ) : (
                          <FaEye size={20} />
                        )}
                      </span>
                    </div>
                  </div>

                  {/* CAPTCHA */}
                  <div className="form-group mb-3 text-center">
                    <canvas
                      ref={canvasRef}
                      width="140"
                      height="40"
                      style={{ border: "1px solid #ddd" }}
                    ></canvas>

                    <button
                      style={{ marginTop: "-33px" }}
                      type="button"
                      onClick={generateCaptcha}
                      className="btn btn-secondary ms-2"
                    >
                      ↻ Refresh
                    </button>
                  </div>

                  <div className="form-group">
                    <label className="form-label">Enter CAPTCHA</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter CAPTCHA"
                      value={userCaptcha}
                      onChange={validateCaptcha}
                    />
                  </div>

                  <div className="d-grid mt-3">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleLoginWithCaptcha}
                    >
                      Login
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="auth-footer row">
              <div className="col my-1">
                <p className="m-0 copyright">
                  Copyright ©{" "}
                  <a href="https://www.mbose.in/" target="_blank">
                    Meghalaya Board of School Education
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="uploadModal"
        tabIndex="-1"
        role="dialog"
        ref={modalRef}
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Set New Password</h5>
              <button
                type="button"
                className="btn-close"
                onClick={closeModal}
              ></button>
            </div>
            <div className="modal-body">
              <div className="row">
                {/* New Password Field */}
                <div className="form-group">
                  <label className="mb-2">New Password</label>
                  <div className="input-group mb-3">
                    <input
                      type={isNewPasswordVisible ? "text" : "password"}
                      className="form-control"
                      placeholder="New Password"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                    />
                    <span
                      className="input-group-text cursor-pointer"
                      onClick={() =>
                        setIsNewPasswordVisible(!isNewPasswordVisible)
                      }
                    >
                      {isNewPasswordVisible ? (
                        <FaEyeSlash size={20} />
                      ) : (
                        <FaEye size={20} />
                      )}
                    </span>
                  </div>

                  {/* Password Strength Meter */}
                  <div className="progress">
                    <div
                      className="progress-bar"
                      role="progressbar"
                      style={{
                        width: `${(passwordStrength.score + 1) * 20}%`,
                        backgroundColor: strengthColors[passwordStrength.score],
                      }}
                    ></div>
                  </div>
                  <small
                    style={{ color: strengthColors[passwordStrength.score] }}
                  >
                    {strengthLabels[passwordStrength.score]}
                  </small>

                  {/* Password Validation Checklist */}
                  <ul className="list-unstyled mt-2">
                    <li style={{ color: hasMinLength ? "green" : "red" }}>
                      {hasMinLength ? "✔" : "✖"} At least 8 characters
                    </li>
                    <li style={{ color: hasUpperCase ? "green" : "red" }}>
                      {hasUpperCase ? "✔" : "✖"} One uppercase letter
                    </li>
                    <li style={{ color: hasLowerCase ? "green" : "red" }}>
                      {hasLowerCase ? "✔" : "✖"} One lowercase letter
                    </li>
                    <li style={{ color: hasNumber ? "green" : "red" }}>
                      {hasNumber ? "✔" : "✖"} One number
                    </li>
                    <li style={{ color: hasSpecialChar ? "green" : "red" }}>
                      {hasSpecialChar ? "✔" : "✖"} One special character
                    </li>
                  </ul>
                </div>

                {/* Confirm Password Field */}
                <div className="form-group">
                  <label className="mb-2">Retype Password</label>
                  <div className="input-group mb-3">
                    <input
                      type={isConfirmPasswordVisible ? "text" : "password"}
                      className="form-control"
                      placeholder="Confirm Password"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                    <span
                      className="input-group-text cursor-pointer"
                      onClick={() =>
                        setIsConfirmPasswordVisible(!isConfirmPasswordVisible)
                      }
                    >
                      {isConfirmPasswordVisible ? (
                        <FaEyeSlash size={20} />
                      ) : (
                        <FaEye size={20} />
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={closeModal}
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSubmit}
              >
                <i className="fa fa-save"></i>&nbsp;Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
